<template>
    <div class="col-md-2 menu-links d-flex flex-column flex-fill sticky-top">
        <div class="row menu-links-header">
            <div class="col-md-9 pt-3 pr-0">
                <img src="@/assets/svg/chevron-down-FFFFFF.svg" alt="">
                <span>Happyrail</span>
                <div class="pt-2 d-flex">
                    <img class="menu-link-header-item" src="@/assets/svg/menu-ffffff.svg">
                    <img class="menu-link-header-item" src="@/assets/svg/search-ffffff.svg">
                    <div class="switch pt-1 mr-2">
                        <label>
                            <input type="checkbox">
                            <span class="lever"></span>
                        </label>
                    </div>
                    <span>Test</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
        <p class="pt-3">Europa</p>
        <test-navigation
            :items="nav.data"
        ></test-navigation>
        <div class="row menu-links-footer">
            <div class="col-md-9 pr-2">
                <div class="d-flex flex-row justify-content-center pt-3">
                    <div class="d-flex flex-row justify-content-between align-items-center px-2 mr-1">
                        <div>
                            <img src="@/assets/svg/dutch-flag.svg">
                        </div>
                        <div>
                            <span>Ned</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-between align-items-center px-3 ml-1">
                        <div>
                            <span>€</span>
                        </div>
                        <div>
                            <span>Eur</span>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center justify-content-center pt-3">
                    <div class="profile-picture d-flex justify-content-center align-items-start pt-2 mr-2">
                        <img src="@/assets/svg/user-check-dddddd.svg">
                    </div>
                    <div>
                        <span class="ml-2 user-name">{{ user }}</span>
                        <span v-if="isLoggedIn"> | <a @click="logout">Logout</a></span>
                    </div>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/services/Navigation'

export default {
  data () {
    return {
      user: this.$store.getters.user,
      nav: {
        data: []
      }
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    }
  },
  async created () {
    this.nav = await Navigation.getAllFake()
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  },
  watch: {
    '$route' () {
      let path = this.$route.path.split('/')
      this.parentClass = 'current'
      if (path.length > 3) {
        let type = this.$route.params.type
        let id = this.$route.params.id
        // Get the new navs (todo: refactor the whole navigation thing)
        if (type && id) {
          this.nav.data = [
            {
              name: 'Info',
              path: '/' + path[1] + '/' + type + '/' + id + '/info'
            },
            {
              name: 'Bezetting',
              path: '/' + path[1] + '/' + type + '/' + id + '/occupancy'
            },
            {
              name: 'Voorraadbeheer',
              path: '/' + path[1] + '/' + type + '/' + id + '/inventory'
            },
            {
              name: 'Faciliteiten',
              path: '/' + path[1] + '/' + type + '/' + id + '/facilities'
            },
            {
              name: 'Reisbescheiden',
              path: '/' + path[1] + '/' + type + '/' + id + '/documents'
            },
            {
              name: 'Content',
              path: '/' + path[1] + '/' + type + '/' + id + '/content'
            },
            {
              name: 'Reviews',
              path: '/' + path[1] + '/' + type + '/' + id + '/reviews'
            }
          ]
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test/Sidebar.vue